/*
 * @Author: Czy 1162306744@qq.com
 * @Date: 2026-03-05 13:49:11
 * @LastEditors: Czy 1162306744@qq.com
 * @LastEditTime: 2026-03-05 15:29:14
 * @FilePath: /ayh-mobile-overseas/src/hooks/useI18n.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import { inject, computed } from 'vue'
import i18n from '@/i18n'

/**
 * 在组件中使用 i18n
 * 用法：
 * const { t, locale } = useI18n()
 * const message = t('common.confirm')
 */
export function useI18n() {
  const injected = inject<any>('i18n', null)

  // 使用全局的 t 函数和 locale
  const globalT = i18n.global.t
  const globalLocale = i18n.global.locale

  return {
    // t 函数始终使用最新的 locale
    t: globalT,
    // locale 是响应式的 ref
    locale: computed({
      get: () => globalLocale.value,
      set: (val: string) => {
        globalLocale.value = val
        console.log('[i18n] Locale changed to:', val)
      },
    }),
  }
}
